import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { LoadingSpinnerComponent } from '@mlc/shared/loading-spinner/loading-spinner.component';
import { MessageBoxComponent } from '@mlc/shared/message-box/message-box.component';
import { RibbonComponent } from '@mlc/shared/ribbon/ribbon.component';
import { ThemeService } from '@mlc/shared/theme-toggle/theme.service';
import { TailwindToastMessageComponent } from '@mlc/shared/toast-message/tailwind-toast-message/tailwind-toast-message.component';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthService } from '../app/core/auth/auth.service';
import { AutosyncCalendarService } from '../app/core/services/autosync-calendar.service';
import { GoogleCalendarService } from '../app/core/services/google-calendar.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, MessageBoxComponent, LoadingSpinnerComponent, TailwindToastMessageComponent, RibbonComponent],
  templateUrl: './app.html',
})
export class App implements OnInit, OnDestroy {
  environment = environment;
  private themeService = inject(ThemeService);
  private authService = inject(AuthService);
  private googleCalendarService = inject(GoogleCalendarService);
  private autosyncCalendarService = inject(AutosyncCalendarService);
  private destroyRef = inject(DestroyRef); // Inject DestroyRef

  constructor() {
    this.themeService.initTheme();
  }

  ngOnInit(): void {
    this.authService
      .getLoggedInUser()
      .pipe(
        switchMap((user) => {
          if (user) {
            return this.googleCalendarService.autoSyncSetting$;
          } else {
            return of(false);
          }
        }),
        takeUntilDestroyed(this.destroyRef), // Pass injected DestroyRef
      )
      .subscribe((autoSyncEnabled) => {
        if (autoSyncEnabled) {
          this.autosyncCalendarService.autoSync();
        }
      });
  }

  ngOnDestroy(): void {
    // takeUntilDestroyed handles unsubscription, but good practice to have this method if implementing OnDestroy
  }
}
